import DeclinedServicesPageContainer from './DeclinedServicesPageContainer';

export default DeclinedServicesPageContainer;



// WEBPACK FOOTER //
// ./src/components/pages/DeclinedServicesPage/index.js